import { CommonModule } from '@angular/common';
import { booleanAttribute, ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'la-panel-header',
  styleUrls: ['./panel-header.component.scss'],
  templateUrl: './panel-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, MatButtonModule, MatIconModule, MatDividerModule],
})
export class PanelHeaderComponent {
  @Input() title?: string;
  @Input() subtitle?: string;

  @Input({ transform: booleanAttribute }) noBack = false;
  @Input() back = true;
  @Input() link = '../';
  @Input() backButton = false;

  @Output() closing = new EventEmitter();
}
